import { Avatar, Box } from "prism-react";

/**
 * @todo implement this in the main Avatar as a variant?
 */
export const StyledAvatar: React.FC<{
  name: string;
  avatarSrc: string | null;
  icon?: React.ReactNode;
  isWorkspace?: boolean;
}> = ({ name, icon, avatarSrc, isWorkspace }) => {
  return (
    <Box
      css={{
        borderRadius: isWorkspace ? 2 : "50%",
        overflow: "hidden",
        position: "relative",
        width: "18px", // these are taken from Avatar size s, not ideal
        height: "18px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        "&::after": {
          content: "",
          borderRadius: isWorkspace ? 2 : "50%",
          width: "100%",
          height: "100%",
          position: "absolute",
          inset: 0,
          boxShadow: "inset 0px 0px 0px 1px rgba(192, 192, 192, .66)",
        },
      }}
    >
      {icon || (
        <Avatar
          name={name}
          shape={isWorkspace ? "block" : "circle"}
          size="s"
          src={avatarSrc}
        />
      )}
    </Box>
  );
};
